export const engagementPlacementCampaignBasesDataV2 = "/engagement/placement_campaign_bases_data_v2";
